// extracted by mini-css-extract-plugin
module.exports = {"card":"tag-module--card--3mNtD","cover":"tag-module--cover--1iekb","content":"tag-module--content--2WX7i"};